(() => {
  const normalize = (value) => String(value || '').trim().toLowerCase();

  const colorFor = (name) => {
    const value = normalize(name);
    const colors = [
      [/black.*champagne|champagne.*black/, 'linear-gradient(135deg, #171717 0 50%, #c6a25c 50% 100%)'],
      [/black.*natural brass|natural brass.*black/, 'linear-gradient(135deg, #171717 0 50%, #bd9852 50% 100%)'],
      [/black.*satin brass|satin brass.*black|black.?gold/, 'linear-gradient(135deg, #171717 0 50%, #b8954f 50% 100%)'],
      [/black.*satin nickel|satin nickel.*black/, 'linear-gradient(135deg, #171717 0 50%, #aaa9a4 50% 100%)'],
      [/black.*brushed aluminum|brushed aluminum.*black/, 'linear-gradient(135deg, #171717 0 50%, #b7bdc0 50% 100%)'],
      [/black.*wood|wood.*black|black.*walnut|walnut.*black|black.*dark teak|dark teak.*black/, 'linear-gradient(135deg, #171717 0 50%, #6a4a32 50% 100%)'],
      [/black.*brown|brown.*black/, 'linear-gradient(135deg, #171717 0 50%, #5b3b2b 50% 100%)'],
      [/white.*champagne|champagne.*white/, 'linear-gradient(135deg, #ffffff 0 50%, #c6a25c 50% 100%)'],
      [/white.*natural brass|natural brass.*white|white.*satin brass|satin brass.*white|white.*gold|gold.*white/, 'linear-gradient(135deg, #ffffff 0 50%, #bd9852 50% 100%)'],
      [/white.*wood|wood.*white/, 'linear-gradient(135deg, #ffffff 0 50%, #8b6848 50% 100%)'],
      [/brushed nickel.*chrome|chrome.*brushed nickel/, 'linear-gradient(135deg, #aaa9a4 0 50%, #dce1e4 50% 100%)'],
      [/chrome.*walnut|walnut.*chrome/, 'linear-gradient(135deg, #dce1e4 0 50%, #63452f 50% 100%)'],
      [/brass.*bronze|bronze.*brass/, 'linear-gradient(135deg, #bd9852 0 50%, #654932 50% 100%)'],
      [/copper.*brown|brown.*copper/, 'linear-gradient(135deg, #b66f4f 0 50%, #5b3b2b 50% 100%)'],
      [/gold.*brown|brown.*gold/, 'linear-gradient(135deg, #c2a15f 0 50%, #5b3b2b 50% 100%)'],
      [/matte white|^white$/, '#fbfaf7'],
      [/ivory|cream|parchment/, '#f1eadc'],
      [/matte black|flat black|brushed black|^black$/, '#171717'],
      [/oil.?rubbed bronze/, '#352a24'],
      [/aged bronze|antique bronze|premium bronze|^bronze$/, '#654932'],
      [/espresso|brown coffee|dark brown|dark wood/, '#3b281f'],
      [/^brown$|gray suede|grey suede/, '#756359'],
      [/beige/, '#d2c0a5'],
      [/muted brass/, '#ae8952'],
      [/aged brass|antique brass|legacy brass/, '#9b7441'],
      [/champagne brass|satin brass|matte brass|brushed brass|shiny brass|^brass$/, '#c2a15f'],
      [/antique gold|brushed gold|^gold$/, '#c4a253'],
      [/satin nickel/, '#aaa9a4'],
      [/brushed nickel/, '#b6b4ae'],
      [/antique nickel/, '#908b80'],
      [/polished nickel|shiny nickel|^nickel$/, '#d0d0cd'],
      [/chrome|aluminum/, 'linear-gradient(135deg, #f3f5f6 0%, #aeb5b9 46%, #e8ecee 65%, #a7afb4 100%)'],
      [/silver|silvers.*grays|silvers.*greys/, '#b8bdc1'],
      [/aged copper|^copper$/, '#a96849'],
      [/gray|grey|graphite/, '#777975'],
      [/sage green/, '#87927a'],
      [/green hair.?on.?hide/, '#65745d'],
      [/blue/, '#4d718e'],
      [/multi.?trim/, 'conic-gradient(#b89137 0 25%, #b8bdc1 25% 50%, #171717 50% 75%, #ffffff 75% 100%)'],
      [/wood|natural|oak|walnut|teak/, '#9c7857'],
      [/clear|crystal/, 'linear-gradient(135deg, #fff 0 42%, #dce7ec 43% 57%, #fff 58%)']
    ];
    return colors.find(([pattern]) => pattern.test(value))?.[1] || null;
  };

  function optionValue(input, label) {
    const text = label?.querySelector('.variant-option__button-label__text')?.textContent?.trim();
    return String(input?.value || text || '').trim();
  }

  function enhanceColorOptions(root = document) {
    root.querySelectorAll('.variant-option').forEach((option) => {
      const inputs = [...option.querySelectorAll('input')];
      const optionName = inputs[0]?.dataset.optionName || option.getAttribute('data-option-name') || option.querySelector('legend')?.textContent || '';
      if (!/(color|colour|finish)/i.test(optionName)) return;

      const swatches = [...option.querySelectorAll('.variant-option__button-label')].map((label) => {
        const input = label.matches('label') ? document.getElementById(label.htmlFor) || label.querySelector('input') : label.querySelector('input');
        const value = optionValue(input, label).trim();
        return { label, value, color: colorFor(value) };
      });
      if (!swatches.length || swatches.some(({ color }) => !color)) {
        option.__orvonNoColor = true;
        return;
      }

      option.classList.add('orvon-color-option');
      option.dataset.orvonOptionName = optionName.replace(/\s*[:：]\s*$/, '').trim();
      let selected = option.querySelector('.orvon-color-option__selected');
      if (!selected) {
        selected = document.createElement('span');
        selected.className = 'orvon-color-option__selected';
        const legend = option.querySelector('legend');
        (legend || option).insertAdjacentElement(legend ? 'afterend' : 'afterbegin', selected);
      }

      swatches.forEach(({ label, value, color }) => {
        label.dataset.orvonFinish = value;
        label.classList.toggle('orvon-color-option__light', /^(matte\s+)?white$/i.test(value));
        label.style.setProperty('--orvon-swatch-color', color, 'important');
        label.style.setProperty('background', color, 'important');
        label.title = value;
        label.setAttribute('aria-label', value);
      });

      const update = () => {
        const checked = option.querySelector('input:checked');
        const label = checked ? option.querySelector(`label[for="${CSS.escape(checked.id)}"]`) : null;
        const value = optionValue(checked, label).trim();
        const selectedText = `${option.dataset.orvonOptionName}: ${value}`;
        if (selected.textContent !== selectedText) selected.textContent = selectedText;
      };
      update();
    });
  }

  let enhancementQueued = false;
  const queueEnhancement = () => {
    if (enhancementQueued) return;
    enhancementQueued = true;
    requestAnimationFrame(() => {
      enhancementQueued = false;
      enhanceColorOptions();
    });
  };

  // Horizon re-renders (morphs) the variant picker after each variant change, which strips the
  // swatch styling. On a slow connection that re-render lands after the timed re-checks below, so
  // the picker fell back to plain text buttons. Watch for it and re-apply whenever it happens.
  const needsEnhancement = () => [...document.querySelectorAll('.variant-option')].some((option) => {
    if (option.__orvonNoColor) return false;
    const name = option.querySelector('input')?.dataset.optionName || option.getAttribute('data-option-name') || option.querySelector('legend')?.textContent || '';
    if (!/(color|colour|finish)/i.test(name)) return false;
    return !option.classList.contains('orvon-color-option') ||
      !option.querySelector('.orvon-color-option__selected') ||
      [...option.querySelectorAll('.variant-option__button-label')].some((label) => !label.style.getPropertyValue('--orvon-swatch-color'));
  });

  const init = () => {
    enhanceColorOptions();
    const observer = new MutationObserver(() => {
      if (needsEnhancement()) queueEnhancement();
    });
    const content = document.getElementById('MainContent') || document.body;
    if (content) observer.observe(content, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('change', (event) => {
    const option = event.target.closest?.('.variant-option');
    if (!option || !/(color|colour|finish)/i.test(option.dataset.orvonOptionName || '')) return;
    queueEnhancement();
    [40, 120, 300, 700].forEach((delay) => setTimeout(queueEnhancement, delay));
  });
  ['variant:update', 'variant:change', 'product:variant-change'].forEach((eventName) =>
    document.addEventListener(eventName, queueEnhancement)
  );
  document.addEventListener('shopify:section:load', (event) => {
    enhanceColorOptions(event.target);
  });
})();

